export const messages = {
  zh: {
    navPolicy: '披露说明',
    navSubmit: '提交问题',
    navAdvisories: '已公开通告',
    navSecurity: 'security.txt',
    langZh: '中文',
    langEn: 'EN',
    heroKicker: 'COORDINATED DISCLOSURE',
    heroCtaSubmit: '提交问题',
    heroCtaPolicy: '阅读披露说明',
    homeCardPolicy: '了解范围、时限与安全港',
    homeCardSubmit: '提交漏洞或安全事件',
    homeCardAdvisories: '查看已协调公开的通告',
    footerPgp: 'PGP 公钥',
    encryptHint: '因漏洞内容敏感，请下载并使用 public PGP key',
    policyTitle: '披露说明',
    tocLabel: '本页目录',
    tocWelcome: '欢迎',
    tocTimeline: '时限与沟通',
    tocScope: '范围',
    tocExclusions: '排除',
    tocProcess: '响应流程',
    tocChannels: '提交渠道',
    tocRules: '研究红线',
    tocDisclosure: '公开说明',
    tocConflict: '争议处理',
    tocHarbor: '安全港',
    tocContact: '联系',
    tocFiles: '公开文件',
    processTitle: '响应流程',
    webSubmit: '通过网页提交',
    mailAlt: '加密邮件备选',
    mailChecklistTitle: '邮件中请至少包含：',
    pgpKeyId: 'Key ID',
    pgpFingerprint: 'Fingerprint',
    downloadSecurity: '查看 security.txt',
    downloadPgp: '下载 PGP 公钥',
    noPgp: '管理员尚未上传公钥，请仍使用加密渠道沟通敏感细节。',
    submitTitle: '提交问题',
    stepContent: '问题内容',
    stepRisk: '风险线索',
    stepContact: '联系与附件',
    typeLabel: '类型',
    typeVuln: '漏洞',
    typeIncident: '事件',
    title: '标题',
    severity: '严重性',
    sevCritical: '严重',
    sevHigh: '高危',
    sevMedium: '中危',
    sevLow: '低危',
    product: '受影响产品',
    productPh: '手填产品与型号，例如 诊断平板 T 系列 1.0',
    description: '详细描述',
    poc: '复现 / POC（纯文本）',
    incidentTime: '发现时间',
    impact: '影响范围',
    next: '下一步',
    prev: '上一步',
    craHint: '以下线索均为选填，用于我们评估处置优先级；如暂无直接证据可选择相应说明项。',
    exploited: '主动利用',
    malware: '恶意代码',
    unknown: '未知',
    yes: '是',
    no: '否',
    evidence: '利用证据来源',
    evSelfMonitor: '自有监测 / 告警系统触发',
    evArtifact: '捕获到可疑文件或样本',
    evPublicPoc: '公开渠道流传的利用方法',
    evThirdParty: '外部机构或安全社区通报',
    evFieldInstance: '现场设备或产线实例可复现',
    evCustomer: '客户或用户侧报告异常',
    evInference: '暂无直接证据，仅风险推断',
    evOther: '其他（请在描述中说明）',
    dimensions: '潜在影响维度',
    dimExposure: '数据可能被窃取或未授权访问',
    dimTamper: '数据或配置可能被篡改',
    dimServiceDisrupt: '服务或设备功能中断 / 异常',
    dimIdentityForge: '身份、指令或固件可能被伪造',
    dimPhysicalSafety: '可能影响车辆 / 设备物理或操作安全',
    dimSupplyChain: '可能经供应链或第三方组件扩散',
    dimPrivacy: '可能涉及个人信息或隐私',
    dimBizContinuity: '可能影响客户业务连续性或售后服务',
    regions: '可能影响地区（逗号分隔）',
    sensitivity: '信息敏感程度',
    senNormal: '普通',
    senSensitive: '敏感',
    senHigh: '高敏感',
    mitigation: '已采取的缓解措施',
    anonymous: '匿名提交',
    reporterName: '姓名（可选）',
    reporterEmail: '联系邮箱',
    captcha: '安全验证',
    captchaHint: '填写图片中的结果',
    captchaRefresh: '换一题',
    captchaOk: '已通过验证',
    attach: '附件',
    attachHint: '最多 5 个，单文件 10MB，合计 20MB；TXT / Markdown / JSON / PDF / PNG / JPG / ZIP',
    attachNeedCaptcha: '请先完成安全验证后再选择附件。',
    submitBtn: '提交',
    portalClosed: '门户暂未开放提交。',
    successTitle: '提交已受理',
    successLead: '请在后续邮件主题中保留该编号。本门户不提供进度查询。',
    successMail: '建议对敏感细节使用 PGP 加密后发至 security.txt 中的 Contact。',
    backHome: '返回首页',
    advTitle: '已公开通告',
    search: '搜索编号 / 标题 / CVE / 产品',
    allSeverity: '全部严重性',
    emptyAdv: '当前没有符合条件的已发布通告。',
    loading: '加载中…',
    published: '已发布',
    cve: 'CVE',
    body: '正文',
    exploitStatus: '利用状态',
    userAction: '用户建议',
    publishedAt: '发布时间',
    lastUpdatedAt: '最近更新',
    affectedFixTitle: '受影响产品及修复',
    affectedProductCol: '受影响产品',
    affectedVersionCol: '受影响版本',
    fixedVersionCol: '修复后版本',
    backList: '返回列表',
    required: '请填写此项',
    tooLong: '超出可输入长度',
    emailInvalid: '邮箱格式不正确',
    submitFail: '提交失败'
  },
  en: {
    navPolicy: 'Policy',
    navSubmit: 'Submit a report',
    navAdvisories: 'Advisories',
    navSecurity: 'security.txt',
    langZh: '中文',
    langEn: 'EN',
    heroKicker: 'COORDINATED DISCLOSURE',
    heroCtaSubmit: 'Submit a report',
    heroCtaPolicy: 'Read the policy',
    homeCardPolicy: 'Scope, timelines and safe harbor',
    homeCardSubmit: 'Report a vulnerability or incident',
    homeCardAdvisories: 'Published coordinated advisories',
    footerPgp: 'PGP public key',
    encryptHint: 'Because vulnerability details are sensitive, please download and use the public PGP key.',
    policyTitle: 'Disclosure policy',
    tocLabel: 'On this page',
    tocWelcome: 'Welcome',
    tocTimeline: 'Timelines and communication',
    tocScope: 'Scope',
    tocExclusions: 'Exclusions',
    tocProcess: 'Response process',
    tocChannels: 'How to report',
    tocRules: 'Research limits',
    tocDisclosure: 'Publication',
    tocConflict: 'Disagreement',
    tocHarbor: 'Safe harbor',
    tocContact: 'Contact',
    tocFiles: 'Public files',
    processTitle: 'Response process',
    webSubmit: 'Submit on the web',
    mailAlt: 'Encrypted email alternative',
    mailChecklistTitle: 'Please include at least:',
    pgpKeyId: 'Key ID',
    pgpFingerprint: 'Fingerprint',
    downloadSecurity: 'View security.txt',
    downloadPgp: 'Download PGP public key',
    noPgp: 'No public key is published yet. Please still encrypt sensitive details when possible.',
    submitTitle: 'Submit a report',
    stepContent: 'Issue',
    stepRisk: 'Risk signals',
    stepContact: 'Contact & files',
    typeLabel: 'Type',
    typeVuln: 'Vulnerability',
    typeIncident: 'Incident',
    title: 'Title',
    severity: 'Severity',
    sevCritical: 'Critical',
    sevHigh: 'High',
    sevMedium: 'Medium',
    sevLow: 'Low',
    product: 'Affected product',
    productPh: 'Free text, e.g. Diagnostic tablet T-series 1.0',
    description: 'Description',
    poc: 'Reproduction / POC (plain text)',
    incidentTime: 'Discovery time',
    impact: 'Impact',
    next: 'Next',
    prev: 'Back',
    craHint: 'Optional. These signals help us prioritize triage; pick the closest option even without hard evidence.',
    exploited: 'Active exploitation',
    malware: 'Malicious code',
    unknown: 'Unknown',
    yes: 'Yes',
    no: 'No',
    evidence: 'Exploitation evidence source',
    evSelfMonitor: 'Triggered by our own monitoring / alerting',
    evArtifact: 'Suspicious file or sample captured',
    evPublicPoc: 'Exploit method circulating publicly',
    evThirdParty: 'Reported by an external org or community',
    evFieldInstance: 'Reproducible on a field device or line instance',
    evCustomer: 'Reported by a customer or end user',
    evInference: 'No direct evidence, risk inference only',
    evOther: 'Other (explain in the description)',
    dimensions: 'Potential impact dimensions',
    dimExposure: 'Data may be stolen or accessed without authorization',
    dimTamper: 'Data or configuration may be tampered with',
    dimServiceDisrupt: 'Service or device function disrupted / abnormal',
    dimIdentityForge: 'Identity, command, or firmware may be forged',
    dimPhysicalSafety: 'May affect vehicle / device physical or operational safety',
    dimSupplyChain: 'May spread via supply chain or third-party components',
    dimPrivacy: 'May involve personal data or privacy',
    dimBizContinuity: 'May affect customer business continuity or after-sales service',
    regions: 'Possible regions (comma separated)',
    sensitivity: 'Information sensitivity',
    senNormal: 'Normal',
    senSensitive: 'Sensitive',
    senHigh: 'Highly sensitive',
    mitigation: 'Mitigations already taken',
    anonymous: 'Submit anonymously',
    reporterName: 'Name (optional)',
    reporterEmail: 'Contact email',
    captcha: 'Security check',
    captchaHint: 'Enter the result shown',
    captchaRefresh: 'New question',
    captchaOk: 'Verified',
    attach: 'Attachments',
    attachHint: 'Up to 5 files, 10MB each, 20MB total; TXT / Markdown / JSON / PDF / PNG / JPG / ZIP',
    attachNeedCaptcha: 'Complete the security check before attaching files.',
    submitBtn: 'Submit',
    portalClosed: 'Public intake is currently closed.',
    successTitle: 'Report received',
    successLead: 'Keep this ID in later email subjects. This portal does not provide status lookup.',
    successMail: 'Encrypt sensitive details with the public PGP key and send them to the Contact in security.txt.',
    backHome: 'Home',
    advTitle: 'Published advisories',
    search: 'Search ID / title / CVE / product',
    allSeverity: 'All severities',
    emptyAdv: 'No published advisories match this filter.',
    loading: 'Loading…',
    published: 'Published',
    cve: 'CVE',
    body: 'Details',
    exploitStatus: 'Exploitation',
    userAction: 'Recommended action',
    publishedAt: 'Published',
    lastUpdatedAt: 'Last updated',
    affectedFixTitle: 'Affected products and fixes',
    affectedProductCol: 'Product',
    affectedVersionCol: 'Affected versions',
    fixedVersionCol: 'Fixed version',
    backList: 'Back to list',
    required: 'This field is required',
    tooLong: 'Exceeds the length limit',
    emailInvalid: 'Enter a valid email',
    submitFail: 'Submission failed'
  }
}

export function t(locale, key) {
  const pack = messages[locale] || messages.zh
  return pack[key] || messages.zh[key] || key
}
